"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var language_1 = require("../../../translations/language");
var i18n_1 = __importDefault(require("../../../translations/i18n"));
var RecursiveTemplate_1 = __importDefault(require("../RecursiveTemplate"));
/**
 * Wrapper component for product lists.
 * - Uses i18n library for template translations
 */
var List = function (_a) {
    var orientation = _a.orientation, _b = _a.template, schema = _b.schema, components = _b.components, keys = _b.keys, chain = _b.chain, language = _b.language, listPrice = _a.listPrice, items = _a.items, additionalProps = _a.additionalProps, editorConfigurations = _a.editorConfigurations;
    // TODO: might be bad place to call this function
    (0, language_1.changeLanguage)(language);
    var templateProps = {
        currentComponentSchema: schema.components,
        currentTemplate: components[orientation],
        mediaKeys: keys,
        items: items,
        chain: chain,
        listPrice: listPrice,
        additionalProps: additionalProps,
        editorConfigurations: editorConfigurations
    };
    return (react_1.default.createElement(react_i18next_1.I18nextProvider, { i18n: i18n_1.default },
        react_1.default.createElement(RecursiveTemplate_1.default, __assign({}, templateProps))));
};
exports.default = List;
//# sourceMappingURL=List.js.map